import React from 'react';
import { NavLink } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const links = [
  { to: '/', label: 'ダッシュボード', icon: FiIcons.FiGrid },
  { to: '/webinars', label: 'ウェビナー管理', icon: FiIcons.FiMonitor },
  { to: '/crm', label: '顧客・代理店CRM', icon: FiIcons.FiUsers },
  { to: '/attendees', label: '参加者・アンケート', icon: FiIcons.FiCheckSquare },
  { to: '/workflows', label: '自動配信・ワークフロー', icon: FiIcons.FiGitBranch },
  { to: '/follow-up', label: 'AI追客・商談', icon: FiIcons.FiMessageSquare },
  { to: '/settings', label: '連携・設定', icon: FiIcons.FiSettings }
];

export default function Sidebar() {
  return (
    <aside className="sidebar">
      <NavLink to="/" className="brand">
        <span className="brand-mark"><SafeIcon icon={FiIcons.FiZap} /></span>
        <span><b>WebinarFlow</b><small>SALES AUTOMATION</small></span>
      </NavLink>
      <div className="nav-label">WORKSPACE</div>
      <nav>{links.map(link => <NavLink key={link.to} to={link.to} end={link.to === '/'} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
        <SafeIcon icon={link.icon} /><span>{link.label}</span>
      </NavLink>)}</nav>
      <div className="sidebar-bottom">
        <div className="connection-mini"><span className="connection-dot" /><div><b>ローカルモード</b><small>外部サービス未接続</small></div></div>
        <a className="public-link" href="#/apply"><SafeIcon icon={FiIcons.FiExternalLink} />公開申込フォーム</a>
        <div className="profile"><div className="avatar">AW</div><div><b>営業チーム</b><small>デモワークスペース</small></div><SafeIcon icon={FiIcons.FiMoreHorizontal} /></div>
      </div>
    </aside>
  );
}
